import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import img54 from '../../assets/newimg/logo.png';
import { isBrowser, isMobile } from "react-device-detect";
import { TextField, Typography, CircularProgress, Grid, Paper, Stack, MenuItem, Select, Button, Divider } from "@mui/material";
import oracle from '../../assets/traffic_monster/oracle.png';
import hp from '../../assets/traffic_monster/hp.png';
import honda from '../../assets/traffic_monster/honda.png';
import american_red_cross from '../../assets/traffic_monster/american_red_cross.png';
import nv_energy from '../../assets/traffic_monster/nv_energy.png';
import avery_dennison from '../../assets/traffic_monster/avery_dennison.png';
import corning from '../../assets/traffic_monster/corning.png';
import '../traffic_monster/generated_blogs.css';
import testimonialImg1 from '../../assets/traffic_monster/testimonialImg1.png';
import testimonialImg3 from '../../assets/traffic_monster/testimonialImg3.png';
import testimonialImg4 from '../../assets/traffic_monster/testimonialImg4.jpg';
import { useGetgeneratedBlogListingsQuery, useGetrandomBlogListingsQuery } from '../../redux/api/promptApi';
import common_bg from '../../assets/podcast_monster/common_bg.png';
import { useGenerateBusinessBlogMutation } from '../../redux/api/promptApi';
import { toast } from "react-toastify";
import axios from 'axios';
import headerbg from '../../assets/ocesha_images/landing_new/header_bg.png';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TrustPilotLogo from '../../assets/ocesha_images/trustpilot_logo.png';
import { StarHalf } from "@mui/icons-material";
import StarIcon from '@mui/icons-material/Star';
import section_2 from '../../assets/ocesha_images/landing_new/section_2.png';
import section6_1 from '../../assets/ocesha_images/landing_new/section6_1.png';
import section6_2 from '../../assets/ocesha_images/landing_new/section6_2.png';
import section6_3 from '../../assets/ocesha_images/landing_new/section6_3.png';
import last_section from '../../assets/ocesha_images/landing_new/last_section.png';
import PersonIcon from '@mui/icons-material/Person';
import ocesha_logo from '../../assets/ocesha_images/ocesha_logo.png';
import agency_section_1 from '../../assets/ocesha_images/landing_new_agency/agency_section_1.png';
import agency_section_2 from '../../assets/ocesha_images/landing_new_agency/agency_section_2.png';
import agency_section_4 from '../../assets/ocesha_images/landing_new_agency/agency_section_4.png';
import agency_section_5_1 from '../../assets/ocesha_images/landing_new_agency/agency_section_5_1.png';
import agency_section_5_2 from '../../assets/ocesha_images/landing_new/section6_1.png';
import agency_section_5_3 from '../../assets/ocesha_images/landing_new/section6_2.png';
import agency_section_5_4 from '../../assets/ocesha_images/landing_new_agency/agency_section_5_4.png';
import agency_section_5_5 from '../../assets/ocesha_images/landing_new_agency/agency_section_5_5.png';
import agency_section_7 from '../../assets/ocesha_images/landing_new_agency/agency_section_7.png';
import section_scale_agency from '../../assets/ocesha_images/landing_new_agency/section_scale_agency.png';

const OceshaAgencyLandingNew = () => {

    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentIndexTextTesti, setCurrentIndexTextTesti] = useState(0);
    const [isWideScreen, setIsWideScreen] = useState(false);
    const [isIpadMini, setIsIpadMini] = useState(false);
    const [randomInteger, setRandomInteger] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [blogs, setBlogs] = useState<any>();
    const [randomBlogs, setRandomBlogs] = useState<any>();
    const [httpsVal, setHttpsVal] = useState('https://');
    const [businessBlogMutation] = useGenerateBusinessBlogMutation();
    const [otherOption, setOtherOption] = useState(false);
    const [uploadVideo, setUploadVideo] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uploadedvideopath, setUploadedvideopath] = useState('');
    const [arrowClick1, setArrowClick1] = useState<any>();
    const [arrowClick2, setArrowClick2] = useState<any>();
    const [arrowClick3, setArrowClick3] = useState<any>();
    const [urlPrefix, setUrlPrefix] = useState<string>(/* 'https://' */'youtubeid');
    const [businessUrl, setBusinessUrl] = useState('');
    const [userBusinessText, setUserBusinessText] = useState('');
    const [youtubeUrl, setYoutubeUrl] = useState('');
    const [isScrapcheckloading, setIsScrapcheckloading] = useState<boolean>(false);
    const [contactname, setContactName] = useState<any>();
    const [contactemail, setContactEmail] = useState<any>();
    const [contactPhno, setContactPhNo] = useState<any>();
    const [contactMessage, setContactMessage] = useState<any>();
    const [isContacting, setIsContacting] = useState<boolean>(false);

    const sections = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2, // threshold based on when want the animation to trigger
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible'); // Add 'visible' class when in view
                } else {
                    entry.target.classList.remove('visible'); // Remove class when out of view
                }
            });
        }, observerOptions);

        sections.current.forEach((section) => {
            if (section instanceof Element) {
                observer.observe(section);
            }
        });

        return () => {
            sections.current.forEach((section) => {
                if (section instanceof Element) {
                    observer.unobserve(section);
                }
            });
        };
    }, []);

    const promptid = params.get('promptid') ?? "";

    const videotestimonialData = [
        {
            // image: testimonial_videoImg1,
            video: "https://www.youtube.com/embed/mEyC24nC73k",
            name: "Jay Levin",
            title: "CEO Equip Our Kids LA Weekly Magazine"
        },
        {
            // image: testimonial_videoImg2,
            video: "https://www.youtube.com/embed/bQ694TD-QCE",
            name: "Giovanni Villa",
            title: "CEO Bella2Bello"
        },
        {
            // image: testimonial_videoImg2,
            video: "https://www.youtube.com/embed/KLLaclzl5r0",
            name: "Paul Claxton",
            title: "Managing General Partner"
        }

    ];
    const testimonialCount = videotestimonialData.length;
    /* video testimonial */
    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 3 + testimonialCount) % testimonialCount);
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 3) % testimonialCount);

    };

    const getDisplayedTestimonials = () => {
        let displayedTestimonials = [];
        for (let i = 0; i < 3; i++) {
            displayedTestimonials.push(videotestimonialData[(currentIndex + i) % testimonialCount]);
        }
        return displayedTestimonials;
    };

    const handlePrevMob = () => {
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
    };

    const handleNextMob = () => {
        setCurrentIndex((prevIndex) => (prevIndex === videotestimonialData.length - 1 ? 0 : (isMobile ? prevIndex + 1 : 0)));
    };

    /*  */



    /* 1366x768 resolution for the section(what if you had 1000 AI agents.) */
    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth <= 1366 && window.innerHeight <= 768);
            setIsIpadMini(window.innerWidth <= 1024 && window.innerHeight <= 768);
        };

        handleResize(); // Initial call
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    /*  */

    /* Text testimonial */
    const testimonialtoshow = (isMobile) ? 1 : 3;

    var testimonialsettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: testimonialtoshow,
        slidesToScroll: 1,
        arrows: true,
    };
    const testimonials = [
        {
            name: "CRAIG SHAH/CEO",
            icon: <img src={testimonialImg4} className="img-fluid rounded-circle twitter-padding" alt="" width="49" height="44"></img>,
            content: "Amazing!",
            reference: "EVOKE"
        },
        {
            name: "KURT KUMAR/CEO",
            icon: <img src={testimonialImg3} className="img-fluid rounded-circle twitter-padding" alt="" width="49" height="44"></img>,
            content: "Traffic Monster solves a problem that every business encounters.  How do you get traffic and leads and ultimately sales to your business.",
            reference: "SAPX"
        },
        {
            name: "JAMAL WOODLEY/CEO",
            icon: <img src={testimonialImg1} className="img-fluid rounded-circle twitter-padding" alt="" width="49" height="44"></img>,
            content: "It's very impressive.  I think this is something that every entrepreneur will be excited about..",
            reference: "MINDMADE BRANDS"
        }
    ];
    const testimonialCount1 = testimonials.length;

    const handlePrevTextTesti = () => {
        setCurrentIndexTextTesti((prevIndex) => (prevIndex - 1 + testimonialCount1) % testimonialCount1);
    };

    const handleNextTextTesti = () => {
        setCurrentIndexTextTesti((prevIndex) => (prevIndex + 1) % testimonialCount1);
    };

    const getDisplayedTestimonials1 = () => {
        let displayedTestimonials = [];
        for (let i = 0; i < 3; i++) {
            displayedTestimonials.push(testimonials[(currentIndexTextTesti + i) % testimonialCount1]);
        }
        return displayedTestimonials;
    };
    /*  */

    useEffect(() => {
        // Calculate random integer when totalPages is available
        if (totalPages !== null) {
            const min = 1;
            const max = totalPages;
            const randomInteger = Math.floor(Math.random() * (max - min + 1)) + min;
            setRandomInteger(randomInteger);
        }
    }, [totalPages]);

    /* News portion Blogs */
    const supportEmail: string = process.env.REACT_APP_SUPPORT_EMAIL || '';
    const getBlogs = useGetgeneratedBlogListingsQuery({ promptid: ''/* promptid */, userid: ''/* supportEmail */, limitval: 3, skipval: randomInteger });

    useEffect(() => {
        if (getBlogs.data) {
            setBlogs([...getBlogs.data]);
        }
    }, [getBlogs]);
    /*  */

    /* random customer blogs */
    const getRandomBlogs = useGetrandomBlogListingsQuery({});

    useEffect(() => {
        if (getRandomBlogs.data) {
            setRandomBlogs([...getRandomBlogs.data]);
        }
    }, [getRandomBlogs]);
    /*  */

    // const domain = window.location.hostname;
    const handleReadMoreClick = (userid: any) => {
        window.open(`/blogs?userid=${userid}`, '_blank');
    }

    const supportUserid = process.env.REACT_APP_SUPPORT_USER_ID || '';

    const handleUnload = () => {
        localStorage.removeItem('CreatingfromLanding');
        localStorage.removeItem('UrlfromLanding');
        localStorage.removeItem('user_pass');
        localStorage.removeItem('user_name');
        // localStorage.removeItem('user_email');
    };
    window.addEventListener("beforeunload", handleUnload);

    useEffect(() => {
        localStorage.removeItem('CreatingfromLanding');
        localStorage.removeItem('UrlfromLanding');
        localStorage.removeItem('user_pass');
        localStorage.removeItem('user_name');
        // localStorage.removeItem('user_email');
    }, []);

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const clearLocalStorage = () => {
        const keysToRemove = ["msg", "complexity", "module", "subscription_level", "free_plan", "localStorage_msg", "allSet", "Blogs Generated", "remaining_wish_count", "userRole", "payment", "user_email", "logged_in", "prevImg", "fromUpgrade", "blogsCount", "Generating Count", "finalData", "user_pass", "fromNewcampaign", "campaignid", "returningtocampaign", "sourceurl", "campaignName", "paymentOption", "autoPublish", "limitPublish", "campId", "smUrlpublish", "addTags", "captureLeads", "newsLetter", "twitterBtn", "fbBtn", "pintrestBtn", "linkedinBtn", "video", "twitterurl", "fburl", "pintresturl", "linkedinurl", "owndomain", "ChangepayMode", "IdChangingMode", "user_name", "refreshCount", "publishingCampId", "Authorurl", "Authorname", "authorDefaultCheck", "appsumo_coupon_code", "podcastUrl", "AlertMessage", "CreatingfromLanding", "UrlfromLanding", "signedup", "uploadedvideo", "uploadedVideoName", "uploadStatus"];
        keysToRemove.forEach(key => localStorage.removeItem(key));
    };

    const handleGenerateBlogClick = async (url: string, userid: string, uploadedtext: string, youtubeUrl: any) => {
        clearCookies();
        localStorage.clear();
        if (url) {
            localStorage.clear();

            /* let youtubeMatch = url.match(
                /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\?.*)?/
            ); */

            // if (youtubeMatch) {
            localStorage.setItem('CreatingfromLanding', 'true');
            localStorage.setItem('UrlfromLanding', url);
            if (userid === '') {
                navigate('/signup', { state: { CreatingfromLanding: localStorage.getItem('CreatingfromLanding'), UrlfromLanding: localStorage.getItem('UrlfromLanding') } });
            }
            /* } else if (!youtubeMatch) {
                toast.error('Please enter valid youtube video url!');
            } */
        } else if (youtubeUrl) {
            const youtubeMatch = youtubeUrl?.match(
                /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/

            );

            if (youtubeMatch) {
                localStorage.setItem('CreatingfromLanding', 'true');
                localStorage.setItem('YoutubeUrlfromLanding', youtubeUrl);
                if (userid === '') {
                    navigate('/signup', { state: { CreatingfromLanding: localStorage.getItem('CreatingfromLanding'), UrlfromLanding: localStorage.getItem('UrlfromLanding'), YoutubeUrlfromLanding: localStorage.getItem('YoutubeUrlfromLanding') } });
                }
            } else if (!youtubeMatch) {
                toast.error('Somethign went wrong, check your url format.');
            }
        }
        else if (/* localStorage.getItem('uploadStatus') == 'success' && */ userBusinessText) {
            localStorage.setItem('CreatingfromLanding', 'true');
            localStorage.setItem('uploadedText', userBusinessText);
            if (userid === '') {
                navigate('/signup', { state: { CreatingfromLanding: localStorage.getItem('CreatingfromLanding'), TextfromLanding: localStorage.getItem('uploadedText')/*  VideofromLanding: localStorage.getItem('uploadedvideo') */ } });
            }
        } else if (!url || !uploadedtext) {
            toast.error('Please enter your business url/upload text!');
        }
    }

    const handlevideoChange = async (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setUploadVideo(file.name);
            console.log('Uploaded video file:', file);
            const formData = new FormData();
            formData.append('media_file', file);

            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            setIsLoading(true);
            try {
                const response = await axios.post(
                    `${apiUrl}/api/prompts/upload_media_file`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                console.log(response.data.data);
                if (response.data.result === 'success' && response.data.data) {
                    localStorage.setItem('uploadedVideoName', file.name);
                    localStorage.setItem('uploadStatus', 'success');
                    setUploadedvideopath(response.data.data);
                    toast.success('File Uploaded Successfully!');

                    localStorage.setItem('CreatingfromLanding', 'true');
                    localStorage.setItem('uploadedvideo', response.data.data);
                    // if (localStorage.getItem('user_email') === '') {
                    navigate('/signup', {
                        state: {
                            CreatingfromLanding: localStorage.getItem('CreatingfromLanding'),
                            VideofromLanding: localStorage.getItem('uploadedvideo'),
                            videoNamefromLanding: localStorage.getItem('uploadedVideoName')
                        }
                    });
                    // }
                } else if (response.data.result === 'fail') {
                    toast.error(response.data.message);
                }
            } catch (error) {
                console.error('Error uploading video:', error);
                toast.error('Error uploading video');
            } finally {
                setIsLoading(false);
            }

        }
    };

    const handleTextChange = (event: any) => {
        let inputText = event.target.value;
        setUserBusinessText(inputText);
        localStorage.setItem('CreatingfromLanding', 'true');
        localStorage.setItem('uploadedText', inputText);
    };

    const handlescrapPage = async (url: string) => {
        setIsScrapcheckloading(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.get(
                `${apiUrl}/api/prompts/scrap_page?url=${url}`,
            );
            if (response.data.result === 'failed') {
                toast.error(response.data.data);
            } else {
                handleGenerateBlogClick(url, localStorage.getItem('user_email') || '', userBusinessText, youtubeUrl);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsScrapcheckloading(false);
        }
    }

    const handleUrlPrefixChange = (event: any) => {
        const selectedValue = event.target.value;
        setUrlPrefix(selectedValue);
        console.log('URL Prefix Changed:', selectedValue);
    }

    useEffect(() => {
        console.log('urlPrefix updated:', urlPrefix);
    }, [urlPrefix]);

    const handleGetStartedClick = async () => {
        if (!contactname && !contactemail && !contactPhno && !contactMessage) {
            toast.error('Please fill your details!');
        } else {
            const formData = new FormData();
            formData.append('name', contactname);
            formData.append('email', contactemail);
            formData.append('phone', contactPhno);
            formData.append('subject', contactMessage);
            formData.append('message', contactMessage);
            try {
                setIsContacting(true);
                const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                const response = await axios.post(apiUrl + '/api/auth/contactus', formData, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                if (response.data.status === 'success') {
                    toast.success(response.data.message);
                    setContactName('');
                    setContactEmail('');
                    setContactPhNo('');
                    setContactMessage('');
                } else {
                    toast.error('Please try agin later!');
                }
            } catch (error) {
                console.log('Error while contacting', error);
            } finally {
                setIsContacting(false);
            }
        }
    }

    return (
        <>
            <div style={{ background: '#000' }}>


                {/* Header */}
                <div className="container">
                    <div className="row">
                        <nav className="navbar navbar-expand-md">
                            <div className="container-fluid">
                                <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"} style={{ width: '5%' }}>
                                    {/* <img src="./img/logo.png" alt="" /> */}
                                    <img src={ocesha_logo} className="img-fluid" alt="" style={{ width: '95%' }} />

                                </a>
                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarScroll"
                                    aria-controls="navbarScroll"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="">
                                        <i className="bi bi-list text-white" />
                                    </span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarScroll">
                                    <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll ms-md-5  gap-4">
                                        <li className="nav-item">
                                            <a
                                                className="nav-link nav_active"
                                                style={{ color: "#4ba5eb", fontWeight: 800 }}
                                                href="/"
                                            >
                                                Home
                                            </a>
                                        </li>
                                        <li className="nav-item" onClick={() => {
                                            navigate("/podcast");
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple">
                                                Podcast
                                            </a>
                                        </li>
                                        {/* <li className="nav-item" onClick={() => {
                                            navigate("/agency");
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple">
                                                Agency
                                            </a>
                                        </li>
                                        <li className="nav-item" onClick={() => {
                                            navigate("/small-business");
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple">
                                                Small Business
                                            </a>
                                        </li> */}
                                        <li className="nav-item" onClick={() => {
                                            localStorage.setItem('pricing_from_landing', 'true');
                                            navigate("/pricing");
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple" /* href="https://codegenie.getrewardful.com/signup?_gl=1*wfwhnc*_gcl_au*MTMwOTQ5ODcxNy4xNjkyODU4NDk3*_ga*MTA4OTc3NTMyNC4xNjkyODUzODcz*_ga_YJYFH7ZS27*MTY5Mjg3OTg0NS40LjEuMTY5Mjg4NjM1MC41Mi4wLjA.&_ga=2.74546258.159718116.1692853906-1089775324.1692853873" */>
                                                Pricing
                                            </a>
                                        </li>
                                        {/*  <li className="nav-item" style={{ cursor: 'pointer' }}>
                                        <a className="nav-link nav_simple" href="https://trafficmonsterai.getrewardful.com/signup?revgems-session-id=45a7e1ae-a67a-4197-9973-f002c2338e37&_gl=1*159ev21*_gcl_au*MjI5MjQ3ODg2LjE3MTQ3MzU2NTE.*_ga*MTAyOTUzNzQyMC4xNzE0NzM1NjU0*_ga_YJYFH7ZS27*MTcxNTY3NjkxOC40LjEuMTcxNTY3NzIwMy41MS4wLjA">
                                            Affiliates
                                        </a>
                                    </li> */}
                                        {/* <li className="nav-item" style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple" href="https://trafficmonsterai.getrewardful.com/signup">
                                                Affiliates
                                            </a>
                                        </li> */}

                                        <li className="nav-item" onClick={() => {
                                            navigate("/contactus");
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple" /* href="https://codegenie.getrewardful.com/signup?_gl=1*wfwhnc*_gcl_au*MTMwOTQ5ODcxNy4xNjkyODU4NDk3*_ga*MTA4OTc3NTMyNC4xNjkyODUzODcz*_ga_YJYFH7ZS27*MTY5Mjg3OTg0NS40LjEuMTY5Mjg4NjM1MC41Mi4wLjA.&_ga=2.74546258.159718116.1692853906-1089775324.1692853873" */>
                                                Contact
                                            </a>
                                        </li>
                                        <li className="nav-item" onClick={() => {
                                            window.open(`/blogs`, '_blank');
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple">
                                                Blogs
                                            </a>
                                        </li>
                                        <li className="nav-item" onClick={() => {
                                            navigate("/aboutus");
                                        }} style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple" /* href="https://codegenie.getrewardful.com/signup?_gl=1*wfwhnc*_gcl_au*MTMwOTQ5ODcxNy4xNjkyODU4NDk3*_ga*MTA4OTc3NTMyNC4xNjkyODUzODcz*_ga_YJYFH7ZS27*MTY5Mjg3OTg0NS40LjEuMTY5Mjg4NjM1MC41Mi4wLjA.&_ga=2.74546258.159718116.1692853906-1089775324.1692853873" */>
                                                About Us..
                                            </a>
                                        </li>
                                        <li className="nav-item" style={{ cursor: 'pointer' }}>
                                            <a className="nav-link nav_simple" href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw">
                                                Affiliates
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="d-flex gap-4" role="search" style={{ justifyContent: isMobile ? 'center' : '' }}>
                                        <button className="btn btn-outline-primary px-3"
                                            onClick={() => {
                                                if (localStorage.getItem('logged_in') === 'true') {
                                                    navigate('/codegenie/generated-blogs', { state: { userEmail: localStorage.getItem('user_email') || '' } });
                                                } else {
                                                    navigate("/signin");
                                                }
                                            }}>Sign  In</button>
                                        <button className="button_leniar px-3" type="submit" onClick={() => {
                                            navigate("/signup", { state: { DirectSignup: 'true' } });
                                        }}>
                                            {/* Try Now */}Sign Up
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <hr className="mt-3" style={{ color: "#9aa0a3" }} />
                    </div>
                </div>
                {/*  */}

                <div className="container">

                    {/* Podcast Monster Section */}
                    <div
                        ref={(el) => sections.current[0] = el}
                        className="section podcast-monster-section"
                        style={{
                            backgroundImage: `url(${agency_section_1})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            backgroundBlendMode: 'overlay',
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >

                        <div className="row  mb-5">
                            <div className="col-12 text-white text-center" style={{ padding: '20px' }}>
                                <h2
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '46px',
                                        lineHeight: isMobile ? '1.4' : '1.6'
                                    }}
                                >
                                    OCESHA
                                </h2>
                                <h2
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '33px',
                                        lineHeight: isMobile ? '1.4' : '1.6'
                                    }}
                                >
                                    Deliver Premium Content for Your Agency Clients,<br />Streamline Workflows, and Drive Measurable<br />Results
                                </h2>
                            </div>
                            <div className="row" style={{ justifyContent: isMobile ? 'center' : '', paddingLeft: isMobile ? '7%' : '' }}>
                                <div className="col-sm-12 col-md-1 col-lg-1 d-none">
                                    &nbsp;
                                </div>
                                <div style={{ background: '#0E1015', borderRadius: '12px', padding: '1%' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={2} sx={{
                                            color: '#344054', display: urlPrefix === 'text' ? '' : 'flex',
                                            alignItems: urlPrefix === 'text' ? '' : 'center'
                                        }}>
                                            <Paper
                                                elevation={3}
                                                sx={{
                                                    padding: 1,
                                                    backgroundColor: 'white',
                                                    borderRadius: '4px',
                                                    width: '100%',
                                                }}
                                            >
                                                <Select
                                                    value={urlPrefix}
                                                    onChange={handleUrlPrefixChange}
                                                    // open={false}
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    sx={{
                                                        width: '100%',
                                                        height: '35px',
                                                        '.MuiInputBase-root': {
                                                            height: '100%'
                                                        },
                                                        backgroundColor: 'white',
                                                        color: '#2A313A',
                                                        '& .MuiSelect-icon': {
                                                            color: '#2A313A',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'transparent',
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'transparent',
                                                        },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'transparent',
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="https://">Website URL</MenuItem>
                                                    {/* <MenuItem value="text">Text</MenuItem> */}
                                                    <MenuItem value="youtubeid">Youtube Url</MenuItem>
                                                    {/* <MenuItem value="upload">Upload Video/Audio File</MenuItem> */}
                                                </Select>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12} sm={10}>
                                            <Paper
                                                elevation={3}
                                                sx={{
                                                    padding: 1,
                                                    backgroundColor: 'white',
                                                    borderRadius: '4px',
                                                    width: '100%',
                                                }}
                                            >
                                                {
                                                    urlPrefix === 'https://' ?
                                                        <TextField
                                                            placeholder="Enter your website url"
                                                            sx={{
                                                                backgroundColor: '#fff',
                                                                width: '100%',
                                                                height: '35px',
                                                                '.MuiInputBase-root': {
                                                                    height: '100%'
                                                                },
                                                                pointerEvents: 'block'
                                                            }}
                                                            value={businessUrl}
                                                            onChange={(e) => setBusinessUrl(e.target.value)}
                                                        // id="sourceurl"
                                                        ></TextField> :
                                                        <TextField
                                                            placeholder="Enter Your Youtube url"
                                                            sx={{
                                                                backgroundColor: '#fff',
                                                                width: '100%',
                                                                height: '35px',
                                                                '.MuiInputBase-root': {
                                                                    height: '100%'
                                                                },
                                                                pointerEvents: 'block'
                                                            }}
                                                            value={youtubeUrl}
                                                            onChange={(e) => setYoutubeUrl(e.target.value)}
                                                            id="sourceurl"
                                                        ></TextField>}
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
                                        <button
                                            className="px-3"
                                            type="submit"
                                            style={{
                                                // display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '22px',
                                                fontWeight: 'bold',
                                                width: isMobile ? '74%' : '20%',
                                                borderRadius: '5px',
                                                textAlign: 'center',
                                                filter: isLoading ? 'blur(2px)' : 'none',
                                                pointerEvents: isLoading ? 'none' : 'auto',
                                                height: '65px',
                                                background: '#662D91',
                                                color: '#fff',
                                                cursor: "pointer",
                                                border: 'none'
                                            }}
                                            onClick={() => {
                                                if (businessUrl) {
                                                    handlescrapPage(businessUrl);
                                                } else {
                                                    handleGenerateBlogClick(businessUrl ? businessUrl : '', localStorage.getItem('user_email') || '', userBusinessText, youtubeUrl);
                                                }
                                            }}
                                            disabled={isLoading}
                                        >
                                            {isScrapcheckloading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : <>TRY IT FOR FREE</>}
                                        </button>
                                    </div>

                                    <div className="col-12" style={{ display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            background: '#fff',
                                            width: isMobile ? '40%' : '14%',
                                            gap: '5px',
                                            padding: '10px',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }} onClick={() => window.open('https://www.trustpilot.com/review/ocesha.com', '_blank')}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                justifyContent: 'center'
                                            }}>
                                                <img src={TrustPilotLogo} style={{ width: '15%' }} />
                                                <span style={{
                                                    color: '#000',
                                                    fontWeight: 'bold'
                                                }}>
                                                    TrustPilot
                                                </span>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                gap: '2px'
                                            }}>
                                                {[...Array(4)].map((_, index) => (
                                                    <StarIcon
                                                        key={index}
                                                        style={{
                                                            color: '#FFD700',
                                                            fontSize: '15px'
                                                        }}
                                                    />
                                                ))}
                                                <StarHalf style={{
                                                    color: '#FFD700',
                                                    fontSize: '15px'
                                                }} />
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                gap: '2px',
                                                color: '#000',
                                                fontSize: '12px'
                                            }}>
                                                4.5/5
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-1 col-lg-1 d-none">
                                    &nbsp;
                                </div>
                            </div>

                        </div>
                        <div className="mx-sm-0 mx-2" style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                            {/* <div className="col-12 rounded-1" style={{ width: '85%', padding: isMobile ? '4%' : '1%' }}>
                                <Typography style={{ textAlign: 'center', width: "100%", marginBottom: isMobile ? '14%' : '' }}>By Rohan Hall</Typography>
                                <div className="gap-3 justify-content-center" style={{ display: "flex", flexWrap: isMobile ? 'nowrap' : 'wrap', flexDirection: isMobile ? 'column' : 'row', width: "100%", justifyContent: "center", alignItems: "center", }}>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={oracle} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={hp} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={honda} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={american_red_cross} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={nv_energy} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={avery_dennison} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={corning} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                </div>
                            </div> */}
                            <Typography style={{ textAlign: 'center', width: "100%", /* marginTop: isMobile ? '14%' : '4%', */ fontSize: '27px', color: '#fff', fontWeight: 'bold' }}>Scale Your Agency with AI-Powered Content Creation</Typography>
                        </div>

                    </div>
                    {/* <hr></hr> */}
                    {/* Podcast Monster Section End*/}

                    {/* How ocesha works Section */}
                    <div
                        ref={(el) => sections.current[2] = el}
                        className="section choose-podcastmons-section"
                        style={{
                            backgroundImage: `url(${agency_section_2})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginBottom: '2%' }}>

                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: isBrowser ? '2%' : '' }}>
                                <div className="row">
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>How OceSha Works</h4>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: '2%' }}>
                                <div className="timeline">
                                    <div className="step">
                                        <div className="circle-container">
                                            <div className="circle">1</div>
                                            <div className="vertical-line"></div>
                                        </div>
                                        <div className="additional-text">
                                            <span style={{ fontSize: '17px', fontWeight: 'bold' }}>Create</span><br />
                                            Use AI tools to produce<br />
                                            high-quality blogs,<br />
                                            posts, and images<br />
                                            tailored to each client.
                                        </div>
                                    </div>
                                    <div className="step">
                                        <div className="circle-container">
                                            <div className="circle">2</div>
                                            <div className="vertical-line"></div>
                                        </div>
                                        <div className="additional-text">
                                            <span style={{ fontSize: '17px', fontWeight: 'bold' }}>Optimize</span><br />
                                            Implement advanced<br />
                                            SEO strategies to<br />
                                            improve visibility and<br />
                                            traffic.</div>
                                    </div>
                                    <div className="step">
                                        <div className="circle-container">
                                            <div className="circle">3</div>
                                            <div className="vertical-line"></div>
                                        </div>
                                        <div className="additional-text">
                                            <span style={{ fontSize: '17px', fontWeight: 'bold' }}>Distribute</span><br />
                                            Share content across<br />
                                            multiple platforms with<br />
                                            one click.</div>
                                    </div>
                                    <div className="step">
                                        <div className="circle-container">
                                            <div className="circle">4</div>
                                            <div className="vertical-line"></div>
                                        </div>
                                        <div className="additional-text">
                                            <span style={{ fontSize: '17px', fontWeight: 'bold' }}>Monetize</span><br />
                                            Generate additional<br />
                                            revenue streams for<br />
                                            clients through<br />
                                            affiliate links and<br />
                                            sponsorships.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* How ocesha works Section End */}

                    {/* By rohan hall Section */}
                    <div
                        ref={(el) => sections.current[3] = el}
                        className="section key-features-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-12 rounded-1" style={{ width: '85%', padding: isMobile ? '4%' : '1%' }}>
                                <Typography style={{ textAlign: 'center', width: "100%", marginBottom: isMobile ? '14%' : '' }}>By Rohan Hall</Typography>
                                <div className="gap-3 justify-content-center" style={{ display: "flex", flexWrap: isMobile ? 'nowrap' : 'wrap', flexDirection: isMobile ? 'column' : 'row', width: "100%", justifyContent: "center", alignItems: "center", }}>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={oracle} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={hp} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={honda} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={american_red_cross} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={nv_energy} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={avery_dennison} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                    <div className="my-auto" style={{ flex: "0 0 auto", maxWidth: "150px", margin: "0px" }}>
                                        <img src={corning} className="img-fluid1" alt="" style={{ maxWidth: "100%", height: "auto" }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* By rohan hall Section End */}

                    {/* Why choose ocesha Section */}
                    <div
                        ref={(el) => sections.current[4] = el}
                        className="section key-features-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row">
                            <div className="col-sm-12 col-md-8 col-lg-8" style={{ alignSelf: 'center', marginTop: isMobile ? '4%' : '', paddingLeft: '3%' }}/* style={{ justifyContent: 'flex-end', display: 'flex' }} */>
                                <div className="row">
                                    <div className="col-12">
                                        <p style={{ fontSize: '33px', color: '#fff', fontWeight: 'bold' }}>Why Choose OceSha?</p>
                                    </div>
                                </div>

                                <div className="row" style={{ marginTop: isBrowser ? '8%' : '' }}>
                                    <div className={/* isMobile ? */ "col-sm-12 col-md-1 col-lg-1" /* : "col-sm-12 col-md-2 col-lg-2 d-flex justify-content-end" */} style={{ marginTop: isMobile ? '4%' : '' }}>
                                        <p className={/* isMobile ? "" :  */"responsive-p-custopti"} style={{ background: '#790709', width: isMobile ? '10%' : '70%', borderRadius: '4px', padding: isMobile ? '1%' : '2%', textAlign: 'center', height: '30px' }}>1</p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                                        {/* <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: '105px' }}> */}
                                        {/* <div className="card-body"> */}
                                        <h5 className="card-title" style={{ fontSize: '17px', fontWeight: 'bold' }}>All-in-One Content<br />Platform</h5>
                                        <p className="card-text" style={{ fontSize: '17px', marginTop: '5%', textAlign: 'left' }}>
                                            Create SEO blogs, social<br />posts, and AI-designed<br />images effortlessly.
                                        </p>
                                        {/* </div> */}
                                        {/* </div> */}
                                    </div>

                                    <div className={/* isMobile ? */ "col-sm-12 col-md-1" /* : "col-sm-12 col-md-2 col-lg-2 d-flex justify-content-end" */} style={{ marginTop: isMobile ? '4%' : '' }}>
                                        <p className={/* isMobile ? "" : */ "responsive-p-custopti"} style={{ background: '#790709', width: isMobile ? '10%' : '70%', borderRadius: '4px', padding: isMobile ? '1%' : '2%', textAlign: 'center', height: '30px' }}>2</p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                                        {/* <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: '105px' }}> */}
                                        {/* <div className="card-body"> */}
                                        <h5 className="card-title" style={{ fontSize: '17px', fontWeight: 'bold' }}>SEO Optimization</h5>
                                        <p className="card-text" style={{ fontSize: '17px', marginTop: '5%', textAlign: 'left' }}>
                                            Use AI tools to research<br />competitors, embed long-<br />tail keywords, and boost<br />rankings.
                                        </p>
                                        {/* </div> */}
                                        {/* </div> */}
                                    </div>
                                    {isMobile ? '' : <div className="col-sm-12 col-md-2 col-lg-2" style={{ marginTop: isMobile ? '6%' : '' }}></div>}
                                </div>

                                <div className="row" style={{ marginTop: isMobile ? '' : '4%' }}>
                                    <div className={/* isMobile ? */ "col-sm-12 col-md-1 col-lg-1" /* : "col-sm-12 col-md-2 col-lg-2 d-flex justify-content-end" */} style={{ marginTop: isMobile ? '4%' : '' }}>
                                        <p className={/* isMobile ? "" :  */"responsive-p-custopti"} style={{ background: '#790709', width: isMobile ? '10%' : '70%', borderRadius: '4px', padding: isMobile ? '1%' : '2%', textAlign: 'center', height: '30px' }}>3</p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                                        {/* <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: '105px' }}> */}
                                        {/* <div className="card-body"> */}
                                        <h5 className="card-title" style={{ fontSize: '17px', fontWeight: 'bold' }}>Content Repurposing</h5>
                                        <p className="card-text" style={{ fontSize: '17px', marginTop: '5%', textAlign: 'left' }}>
                                            Transform client videos,<br />podcasts, and content<br />into high-impact blogs.
                                        </p>
                                        {/* </div> */}
                                        {/* </div> */}
                                    </div>

                                    <div className={/* isMobile ? */ "col-sm-12 col-md-1" /* : "col-sm-12 col-md-2 col-lg-2 d-flex justify-content-end" */} style={{ marginTop: isMobile ? '4%' : '' }}>
                                        <p className={/* isMobile ? "" : */ "responsive-p-custopti"} style={{ background: '#790709', width: isMobile ? '10%' : '70%', borderRadius: '4px', padding: isMobile ? '1%' : '2%', textAlign: 'center', height: '30px' }}>4</p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                                        {/* <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: '105px' }}> */}
                                        {/* <div className="card-body"> */}
                                        <h5 className="card-title" style={{ fontSize: '17px', fontWeight: 'bold' }}>Multi-Client Management</h5>
                                        <p className="card-text" style={{ fontSize: '17px', marginTop: '5%', textAlign: 'left' }}>
                                            Handle multiple client<br />accounts from a single<br />platform.
                                        </p>
                                        {/* </div> */}
                                        {/* </div> */}
                                    </div>
                                    {isMobile ? '' : <div className="col-sm-12 col-md-2 col-lg-2" style={{ marginTop: isMobile ? '6%' : '' }}></div>}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 col-lg-4 d-flex justify-content-start">
                                <img src={agency_section_4} style={{
                                    width: /* isMobile ?  */'100%' /* : '338px' */,
                                    maxWidth: '100%'
                                }}></img>
                            </div>
                        </div>
                    </div>
                    {/* Why choose ocesha Section End */}

                    {/* Key Benefits Section */}
                    <div
                        ref={(el) => sections.current[5] = el}
                        className="section choose-podcastmons-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginBottom: '2%' }}>

                            <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: '2%', paddingLeft: '3%' }}>
                                <img src={agency_section_5_1} style={{
                                    width: /* isMobile ?  */'100%' /* : '338px' */,
                                    maxWidth: '100%'
                                }}></img>
                                {/* <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>Built for Results</h4>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-sm-8 col-md-8 col-lg-8" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: '5%' }}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>Key Benefits for Your Agency</h4>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <img src={agency_section_5_2} style={{ width: '65px', display: 'flex', alignItems: 'left' }} />
                                                <h5 className="card-title" style={{ fontSize: '18px', color: '#fff', textAlign: 'left', marginTop: '6%' }}>Faster Turnaround</h5>
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left', marginTop: '5%', fontWeight: 'normal' }}>
                                                    Accelerate client campaign delivery<br />
                                                    times.
                                                </p>
                                                {/* <Button sx={{ background: '#F65F62', color: '#000', fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center', padding: '3%' }}>Learn More</Button> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <img src={agency_section_5_3} style={{ width: '65px', display: 'flex', alignItems: 'left' }} />
                                                <h5 className="card-title" style={{ fontSize: '18px', color: '#fff', textAlign: 'left', marginTop: '6%' }}>Enhanced Visibility</h5>
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left', marginTop: '5%', fontWeight: 'normal' }}>
                                                    Boost engagement with SEO-optimized<br />
                                                    content.
                                                </p>
                                                {/* <Button sx={{ background: '#F65F62', color: '#000', fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center', padding: '3%' }}>Learn More</Button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <img src={agency_section_5_4} style={{ width: '70px', display: 'flex', alignItems: 'left', marginTop: '6px' }} />
                                                <h5 className="card-title" style={{ fontSize: '18px', color: '#fff', textAlign: 'left', marginTop: '6%' }}>Scalable Workflows</h5>
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left', marginTop: '5%', fontWeight: 'normal' }}>
                                                    Manage more clients with ease.
                                                </p>
                                                {/* <Button sx={{ background: '#F65F62', color: '#000', fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center', padding: '3%' }}>Learn More</Button> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <img src={agency_section_5_5} style={{ width: '65px', display: 'flex', alignItems: 'left' }} />
                                                <h5 className="card-title" style={{ fontSize: '18px', color: '#fff', textAlign: 'left', marginTop: '6%' }}>Tailored Solutions</h5>
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left', marginTop: '5%', fontWeight: 'normal' }}>
                                                    Customize for each client's unique brand<br />
                                                    and goals.
                                                </p>
                                                {/* <Button sx={{ background: '#F65F62', color: '#000', fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center', padding: '3%' }}>Learn More</Button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Key Benefits Section End */}

                    {/* Monetization and Collaboration Section */}
                    <div
                        ref={(el) => sections.current[6] = el}
                        className="section choose-podcastmons-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginBottom: '2%' }}>

                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: '2%' }}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>Monetization and Collaboration</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '18px', color: '#fff', textAlign: 'left', marginTop: '6%' }}>Monetization Tools</h5>
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left', marginTop: '5%', fontWeight: 'normal' }}>
                                                    Add affiliate links and sponsorships to blogs for client<br />revenue opportunities. Generate additional income<br />streams effortlessly.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '18px', color: '#fff', textAlign: 'left', marginTop: '6%' }}>Collaborative Workspace</h5>
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left', marginTop: '5%', fontWeight: 'normal' }}>
                                                    Approve, edit, and share content with your team and<br />clients seamlessly. Streamline communication and<br />workflow processes.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Monetization and Collaboration Section End */}

                    {/* Streamline your content Section */}
                    <div
                        ref={(el) => sections.current[7] = el}
                        className="section key-features-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row">
                            {/* <div className="col-sm-12 col-md-1 col-lg-1"></div> */}
                            <div className="col-sm-12 col-md-5 col-lg-5 d-flex justify-content-start" style={{ alignSelf: 'center', paddingLeft: '3%' }}>
                                <img src={agency_section_7} style={{
                                    width: /* isMobile ?  */'100%' /* : '338px' */,
                                    maxWidth: '100%',
                                    marginTop: isMobile ? '5%' : ''
                                }}></img>
                            </div>
                            <div className="col-sm-12 col-md-7 col-lg-7" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: '5%' }}>
                                <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>Streamline Your Content<br />Creation</h4>
                                <div className="chevron-container" style={{ marginTop: '9%' }}>
                                    <div className="chevron-item">
                                        <div className="chevron">1</div>
                                        <div className="content">
                                            <p style={{ fontSize: '17px', fontWeight: 'bold' }}>AI-Powered Writing</p>
                                            <p>Generate high-quality content in minutes, saving<br />time and resources.</p>
                                        </div>
                                    </div>

                                    <div className="chevron-item">
                                        <div className="chevron">2</div>
                                        <div className="content">
                                            <p style={{ fontSize: '17px', fontWeight: 'bold' }}>Automated SEO</p>
                                            <p>Optimize content for search engines without manual<br />effort.</p>
                                        </div>
                                    </div>

                                    <div className="chevron-item">
                                        <div className="chevron">3</div>
                                        <div className="content">
                                            <p style={{ fontSize: '17px', fontWeight: 'bold' }}>Multi-Platform Distribution</p>
                                            <p>Publish across various channels with a single click.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Streamline your content Section End */}

                    {/* scale your agency operations section */}
                    <div
                        ref={(el) => sections.current[8] = el}
                        className="section choose-podcastmons-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginBottom: '2%' }}>

                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: '2%' }}>
                                <div className="row">
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>Scale Your Agency Operations</h4>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12" /* style={{ marginTop: '2%' }} */>
                                <div className="row">
                                    <img src={section_scale_agency} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* scale your agency operations section end */}

                    {/* transform your agency today Section */}
                    <div
                        ref={(el) => sections.current[9] = el}
                        className="section choose-podcastmons-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginBottom: '2%' }}>

                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: '2%' }}>
                                <div className="row">
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold', textAlign: 'left' }}>Transform Your Agency Today!</h4>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12" /* style={{ marginTop: '2%' }} */>
                                <div className="row">
                                    {/* <div className="col-sm-12 col-md-1 col-lg-1" style={{ marginTop: isMobile ? '6%' : '' }}></div> */}
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="card" style={{ width: '100%', overflow: 'hidden', background: 'none', border: 'none' }}>
                                            <div className="card-body">
                                                <p className="card-text" style={{ fontSize: '16px', color: '#fff', textAlign: 'left'/* , marginTop: '10%' */, fontWeight: 'normal' }}>
                                                    Try OceSha for free and see how AI can help you scale and deliver exceptional results for your clients.
                                                </p>
                                                <Button sx={{
                                                    background: '#F65F62', color: '#000', fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center', padding: '1%', width: isMobile ? '100%' : '16%',
                                                    '&:hover': {
                                                        background: '#F65F62',
                                                        color: '#000',
                                                    },
                                                }} onClick={() => sections.current[0]?.scrollIntoView({ behavior: 'smooth' })}>Start Free Trial</Button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-2 col-lg-2" style={{ marginTop: isMobile ? '6%' : '' }}></div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* transform your agency today Section End */}

                    {/* Testimonials Section */}
                    <div
                        ref={(el) => sections.current[10] = el}
                        className="section benefit-features-section"
                        style={{
                            // backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            // backgroundColor: '#eeb0b1', // Overlay color with reduced opacity
                            backgroundColor: '#B9474A',
                            // backgroundBlendMode: 'overlay', // Blends the image with the overlay color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginBottom: '2%' }}>

                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: '2%' }}>
                                <div className="row">
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                    <div className="col-sm-12 col-md-12 col-lg-12" style={{ paddingLeft: '3%' }}>
                                        <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold' }}>Testimonials</h4>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-3 col-lg-3"></div> */}
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12" style={{ marginTop: '2%', paddingLeft: '3%', paddingRight: '3%' }}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '6%' : '' }}>
                                        <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: /* isMobile ? */ '100%' /* : '105px' */ }}>
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'left', display: 'flex', alignItems: 'center' }}><PersonIcon sx={{ fontSize: '35px' }} />Thomas White</h5>
                                                <p className="card-text" style={{ fontSize: '15px' }}>
                                                    Our social media engagement rates have skyrocketed since we started using Ocesha. The interactive content and thoughtful personalization make our posts stand out.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '6%' : '' }}>
                                        <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: /* isMobile ? */ '100%' /* : '105px' */ }}>
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'left', display: 'flex', alignItems: 'center' }}><PersonIcon sx={{ fontSize: '35px' }} />Owen Scott</h5>
                                                <p className="card-text" style={{ fontSize: '15px' }}>
                                                    I never thought content creation could be this easy. OceSha’s AI-powered tools are miles ahead of the competition. My favorite feature is the multimodal blogs—it’s so engaging for my audience!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-4" style={{ marginTop: isMobile ? '6%' : '' }}>
                                        <div className="card" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden', background: '#790709', height: /* isMobile ? */ '100%'/*  : '105px' */ }}>
                                            <div className="card-body">
                                                <h5 className="card-title" style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'left', display: 'flex', alignItems: 'center' }}><PersonIcon sx={{ fontSize: '35px' }} />Jeffrey Cook</h5>
                                                <p className="card-text" style={{ fontSize: '15px' }}>
                                                    OceSha has truly simplified my life. The AI captures my brand voice flawlessly, and the one-click distribution feature is a total game-changer. I absolutely love it!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Testimonials Section End */}

                    {/* FAQ Section */}
                    <div
                        ref={(el) => sections.current[11] = el}
                        className="section faq-questions-section"
                        style={{
                            backgroundImage: `url(${common_bg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)', // To add a darker overlay
                            backgroundBlendMode: 'overlay', // Blends the image with the background color
                            padding: isMobile ? '20px' : '50px',
                            borderRadius: '12px',
                            color: '#fff'
                        }}
                    >
                        <div className="row" style={{ marginTop: '5%' }}>
                            <h4 style={{ color: '#fff', fontSize: '33px', fontWeight: 'bold' }}>OceSha FAQ</h4>
                            <div className="col-sm-12 col-md-6 col-lg-6" style={{ textAlign: 'center'/* , marginTop: '5%' */ }}>
                                <div style={{ marginTop: '3%' }}>
                                    <p style={{ color: '#fff', fontSize: '40px' }}>Do you have<br />
                                        any questions?</p>
                                    <p style={{ color: '#fff', fontSize: '16px' }}>Feel free to send us your questions or request a free consultation.</p>
                                </div>

                                <div className="row" style={{ display: 'flex', gap: '12px', /* marginTop: '4%', */ flexDirection: 'column' }}>
                                    <div className="col-12" style={{ display: 'flex', gap: '4px' }}>
                                        <div className="col-6">
                                            <TextField placeholder="Enter Your Full Name" sx={{
                                                height: '45px',
                                                width: '100%',
                                                '.MuiInputBase-root': {
                                                    height: '100%'
                                                }
                                            }} value={contactname} onChange={(e) => setContactName(e.target.value)}></TextField>
                                        </div>
                                        <div className="col-6">
                                            <TextField placeholder="Enter Your Email" sx={{
                                                height: '45px',
                                                width: '100%',
                                                '.MuiInputBase-root': {
                                                    height: '100%'
                                                }
                                            }} value={contactemail} onChange={(e) => setContactEmail(e.target.value)}></TextField>
                                        </div>
                                    </div>
                                    <div className="col-12" style={{ display: 'flex', gap: '4px' }}>
                                        <div className="col-6">
                                            <TextField placeholder="Enter Your PhoneNumber" sx={{
                                                height: '45px',
                                                width: '100%',
                                                '.MuiInputBase-root': {
                                                    height: '100%'
                                                }
                                            }} value={contactPhno} onChange={(e) => setContactPhNo(e.target.value)}></TextField>
                                        </div>
                                        <div className="col-6">
                                            <TextField placeholder="Let us know about your query..." sx={{
                                                height: '45px',
                                                width: '100%',
                                                '.MuiInputBase-root': {
                                                    height: '100%'
                                                }
                                            }} value={contactMessage} onChange={(e) => setContactMessage(e.target.value)}></TextField>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <Button sx={{
                                            background: '#F65F62', color: '#000', fontSize: '14px', fontWeight: 'bold', height: '45px', width: '100%',
                                            '&:hover': {
                                                background: '#F65F62',
                                                color: '#000',
                                            }
                                        }} onClick={handleGetStartedClick}>{isContacting ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : "Get Started"}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6" style={{ justifyContent: 'center', flexDirection: 'column', width: isMobile ? '100%' : '', alignItems: 'center', marginTop: isMobile ? '10%' : '' }}>

                                <div className="accordion" id="regularAccordionRobots">
                                    <div className="rounded-2 mb-2">
                                        <h2 id="regularHeadingFirst" className="accordion-header">
                                            <button
                                                className="accordion-button accordion_style px-3"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#regularCollapseFirst"
                                                aria-expanded="true"
                                                aria-controls="regularCollapseFirst"
                                                style={{ color: '#fff' }}
                                            >
                                                What is OceSha?
                                            </button>
                                        </h2>
                                        <div
                                            id="regularCollapseFirst"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="regularHeadingFirst"
                                            data-bs-parent="#regularAccordionRobots"
                                        >
                                            <div className="accordion-body">
                                                OceSha is an AI-powered content creation and distribution platform that helps agencies streamline workflows and deliver premium results for their clients.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rounded-2 mb-2">
                                        <h2 id="regularHeading2" className="accordion-header">
                                            <button
                                                className="accordion-button accordion_style px-3"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#regularCollapse2"
                                                aria-expanded="false"
                                                aria-controls="regularCollapse2"
                                                style={{ color: '#fff' }}
                                            >
                                                Can OceSha manage multiple client accounts?
                                            </button>
                                        </h2>
                                        <div
                                            id="regularCollapse2"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="regularHeadingFirst"
                                            data-bs-parent="#regularAccordionRobots"
                                        >
                                            <div className="accordion-body">
                                                Yes, OceSha is designed to handle multiple client accounts seamlessly, making it ideal for agencies.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rounded-2 mb-2">
                                        <h2 id="regularHeading3" className="accordion-header">
                                            <button
                                                className="accordion-button accordion_style px-3"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#regularCollapse3"
                                                aria-expanded="false"
                                                aria-controls="regularCollapse3"
                                                style={{ color: '#fff' }}
                                            >
                                                How does OceSha improve SEO for my clients?
                                            </button>
                                        </h2>
                                        <div
                                            id="regularCollapse3"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="regularHeading3"
                                            data-bs-parent="#regularAccordionRobots"
                                        >
                                            <div className="accordion-body">
                                                OceSha uses AI to embed long-tail keywords, analyze trends, and optimize internal and external links to improve search engine rankings.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rounded-2 mb-2">
                                        <h2 id="regularHeading4" className="accordion-header">
                                            <button
                                                className="accordion-button accordion_style px-3"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#regularCollapse4"
                                                aria-expanded="false"
                                                aria-controls="regularCollapse4"
                                                style={{ color: '#fff' }}
                                            >
                                                Is OceSha scalable for larger agencies?
                                            </button>
                                        </h2>
                                        <div
                                            id="regularCollapse4"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="regularHeading4"
                                            data-bs-parent="#regularAccordionRobots"
                                        >
                                            <div className="accordion-body">
                                                Absolutely! OceSha adapts to agencies of all sizes and can scale with your growing client base.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rounded-2 mb-2">
                                        <h2 id="regularHeading5" className="accordion-header">
                                            <button
                                                className="accordion-button accordion_style px-3"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#regularCollapse5"
                                                aria-expanded="false"
                                                aria-controls="regularCollapse5"
                                                style={{ color: '#fff' }}
                                            >
                                                How can OceSha help monetize content for my clients?
                                            </button>
                                        </h2>
                                        <div
                                            id="regularCollapse5"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="regularHeading5"
                                            data-bs-parent="#regularAccordionRobots"
                                        >
                                            <div className="accordion-body">
                                                OceSha offers monetization tools like affiliate links and sponsorship integrations to generate revenue for your clients.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div >


            </div>
        </>
    )
}

export default OceshaAgencyLandingNew;